import { v4 as uuidv4 } from 'uuid';

export function createNewCorridorAwarenessAssessment(customer, assessmentType, awarenessQuestions) {
    const score = Object.values(awarenessQuestions.areCorridorsHelping).filter(item => item.answer === true).length
    return {
        uuid: uuidv4(),
        customerUuid: customer.uuid,
        assessmentType: assessmentType,
        awarenessQuestions: awarenessQuestions,
        assessmentName: "Corridor Awareness Assessment",
        description: `Corridor Awareness Assessment for ${customer.name}`,
        score: score,
        scoredAt: new Date().toISOString(),
        created_at: new Date().toISOString(),
    }
}

export function createEmptyFieldSurveyAssessment(customerUuid, fieldUuid) {

    return {
        uuid: uuidv4(),
        customerUuid: customerUuid,
        assessmentType: 'FieldSurvey',
        fieldUuid: fieldUuid,
        created_at: new Date().toISOString(),
    }
}

// The first value that isn't blank (a 0 counts), else undefined: the register form's check only refuses null.
export function present(...values) {
    return values.find(v => v !== undefined && v !== null && v !== '' && !(Array.isArray(v) && v.length === 0));
}

// { village, ward, farmLocation } from a region, or null when it has neither village nor ward.
// Before Nov 2024 the region picker stored the village as an object ({ village, wards, locations }).
export function regionOf(region) {
    if (!region) { return null; }
    const village = (region.village && typeof region.village === 'object') ? region.village.village : region.village;
    if (!present(village, region.ward)) { return null; }
    return { village: present(village), ward: present(region.ward), farmLocation: present(region.farmLocation) };
}

// A farmer's Ecoexist answers: what connect/ stores first, economic.payload.basicInfo after.
export function ecoBwAnswers(customer) {
    const demographic = customer.demographic || {};
    const economic    = customer.economic || {};
    const payload     = economic.payload || {};
    const stored      = payload.basicInfo || {};
    const geographics = demographic.geographicsArray || [];
    return {
        familySize:   present(economic.dependants, economic.familySize, stored.familySize),
        yearsFarming: present(economic.incomePeriod, economic.yearsFarming, stored.yearsFarming),
        transport:    present(economic.transport, stored.transport),
        livelihood:   present(payload.livelihood, economic.livelihood, stored.livelihood),
        ethnicity:    present(demographic.ethnicity, (stored.ethnicity || {}).answer),
        region:       regionOf(demographic.region) || regionOf({ village: geographics[0], ward: geographics[1] }) || regionOf(stored.region),
    };
}

export function seasonFromDate(date) {
    if(date.getMonth() < 9) {
        return date.getFullYear()
    } else {
        return date.getFullYear() + 1
    }
}
